import { useState, useEffect } from 'react';
import coreAPIService from '../apiServices/coreAPIService';
import { CTW_API_ENDPOINT, CTW_NODE_API_ENDPOINT } from '../utils';
import { toast } from '../common/Popover';
import { Meta } from '../interfaces/apiMeta';
import {
    SavedAudiencesResponse,
    CustomAudiencesResponse,
    AudienceEstimateResponse
} from '../interfaces/apiTypes';
import { handleApiError } from '../utils/errorHandler';

interface Item {
    id: string;
    name: string;
}

export const useAudiences = (selectedAdAccountId: string, orgId: string) => {
    const [items, setItems] = useState<Item[]>([]);
    const [customItems, setCustomItems] = useState<Item[]>([]);
    const [filteredItems, setFilteredItems] = useState<Item[]>([]);
    const [savedAdSetName, setSavedAdSetName] = useState<{
        id: string | null;
        name: string | null;
    }>({ id: null, name: null });
    const [customAdSet, setCustomAdSet] = useState<{
        id: string | null;
        name: string | null;
    }>({ id: null, name: null });
    const [estimatedReach, setEstimatedReach] = useState<number | null>(null);
    const [useSavedAudiences, setUseSavedAudiences] = useState<boolean>(false);
    const [useCustomAudiences, setUseCustomAudiences] = useState<boolean>(false);

    // Fetch audiences when ad account is selected
    useEffect(() => {
        fetchAudiences();
    }, [selectedAdAccountId]);

    const fetchAudiences = async () => {
        const storedAcc = selectedAdAccountId;
        if (!storedAcc) return;
        try {
            const [customRes] = await Promise.all([
                // coreAPIService.get<SavedAudiencesResponse>(
                //     CTW_API_ENDPOINT,
                //     `v2/meta-integration/adaccounts/${storedAcc}/saved-audiences`
                // ),
                coreAPIService.get<CustomAudiencesResponse>(
                    CTW_API_ENDPOINT,
                    `v2/meta-integration/adaccounts/${storedAcc}/custom-audiences?orgId=${orgId}`
                ),
            ]);

            // setItems(savedRes.data || []);
            setCustomItems(customRes.data || []);
            // setFilteredItems(savedRes.data || []);
        } catch (err) {
            handleApiError(
                err,
                `v2/meta-integration/adaccounts/${storedAcc}/audiences`,
                'Failed to load audiences'
            );
        }
    };

    const handleSearch = (value: string) => {
        const filtered = items.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredItems(filtered);
    };

    const handleCustomSearch = (value: string) => {
        const filtered = customItems.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase())
        );
        setCustomItems(filtered);
    };

    // const handleSelect = async (item: Item) => {
    //     setSavedAdSetName(item);

    //     try {
    //         if (!orgId) {
    //             toast('error', 'Account not found');
    //             return;
    //         }

    //         const response = await coreAPIService.get<AudienceEstimateResponse>(
    //             CTW_NODE_API_ENDPOINT,
    //             `/management/v1/getSavedAudienceEstimate/${orgId}?audienceId=${item.id}&adAccountId=${selectedAdAccountId}`
    //         );

    //         if (response.meta.success) {
    //             setEstimatedReach(response.data.approximateCountUpperBound || 0);
    //         } else {
    //             toast('error', 'Failed to fetch audience estimate');
    //         }
    //     } catch (error) {
    //         handleApiError(
    //             error,
    //             `/management/v1/getSavedAudienceEstimate`,
    //             'Failed to fetch audience estimate'
    //         );
    //     }
    // };

    const handleCustomSelect = async (item: Item) => {
        setCustomAdSet(item);
    };

    const handleClearSelection = () => {
        setSavedAdSetName({ id: null, name: null });
    };

    const handleClearSelectionCustom = () => {
        setCustomAdSet({ id: null, name: null });
    };

    const handleAudienceTypeChange = (key: string) => {
        if (key === 'create') {
            setUseSavedAudiences(false);
            setUseCustomAudiences(false);
            setCustomAdSet({ id: null, name: null });
        } else if (key === 'saved') {
            setUseSavedAudiences(true);
            setUseCustomAudiences(false);
            setCustomAdSet({ id: null, name: null });
        } else if (key === 'custom') {
            setUseCustomAudiences(true);
            setUseSavedAudiences(false);
            setSavedAdSetName({ id: null, name: null });
        }
    };

    return {
        items,
        customItems,
        filteredItems,
        savedAdSetName,
        customAdSet,
        estimatedReach,
        useSavedAudiences,
        useCustomAudiences,
        handleSearch,
        handleCustomSearch,
        handleCustomSelect,
        handleClearSelection,
        handleClearSelectionCustom,
        handleAudienceTypeChange,
        fetchAudiences
    };
};
